import _ from 'lodash'

import { request } from './request'

interface IUpdateBoardDataParams {
  description?: string
  name?: string
  unique_name?: string
  is_trashed?: boolean
  parent_id?: string
}

export const publicBoardsApi = {
  updateBoardData: (userId, shareId, nodeId, data: IUpdateBoardDataParams) => {
    return request('PATCH',`/api/3/users/${userId}/shared_with_me/fs/${shareId}/nodes/${nodeId}`, data)
  },
  
  // Update board field value (e.g., tags/status) in shared-with-me context
  updateBoardFields: async (
    userId: number,
    shareId: string,
    nodeId: string,
    fieldID: string,
    data: any,
    signal?: AbortSignal
  ): Promise<any> => {
    return request('PUT', `/api/2/users/${userId}/shared_with_me/fs/${shareId}/nodes/${nodeId}/fields/${fieldID}`, data, { signal })
  },
  
  deleteBoardFields: async (
    userId: number,
    shareId: string,
    nodeId: string,
    fieldID: string,
    signal?: AbortSignal
  ): Promise<any> => {
    return request('DELETE', `/api/2/users/${userId}/shared_with_me/fs/${shareId}/nodes/${nodeId}/fields/${fieldID}`, { signal })
  },
  getNodeLink: (node: any): string => {
    const urlTemplate = _.template(node?._links?.node?.href, { interpolate: /\{(.+?)\}/g })
    const nodeLink = urlTemplate({ node_id: node.node_id })
    return nodeLink
  },
  getNodeData: (nodeLink: string): Promise<any> => {
    return request('GET', nodeLink, {}, { host: null })
  },
  getFieldsData: (fieldsLink: string): Promise<any> => {
    return request('GET', fieldsLink, undefined, { host: null })
  },
}
